import {createContext} from "react";
import type {AppFormInstance} from "shared/UI/UIKit/Form";

export const EditableContext = createContext<AppFormInstance<any> | null>(null);